import {
  GET_MESSAGES,SEND_MESSSAGE,DELETE_MESSAGE,LOAD_MORE_MESSAGES,ADD_MESSSAGE,CHANGE_CHAT,ADD_CHAT_SUBSCRIPTION
} from '../actions/types';

const initialState = {
  messages: [],
  idlist:[],
  lastVisible: null,
  getDone:false,
  isListening:false,
  subscribedList:[],
  currentChat:'main'
};

const chatReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_MESSAGES:
      var newmessages = action.payload.messageArray;
      var lastVisible = action.payload.lastVisible;
      var ids = action.payload.messageArray.map(msg=>{return(msg._id)})
      return {
        ...state,
        idlist:ids,
        getDone:true,
        messages: newmessages,
        lastVisible: lastVisible,
      };
    case LOAD_MORE_MESSAGES:
      var newmessages = action.payload.messageArray;
      var lastVisible = action.payload.lastVisible;

      return {
        ...state,  
        messages: state.messages.concat(newmessages),
        lastVisible: lastVisible,
      };

    case ADD_MESSSAGE:  
      if(action.payload && action.payload.chatroom == state.currentChat){

      
      if(state.messages.length > 0 && action.currentChat == state.currentChat){   
      
        if(!state.idlist.includes(action.payload._id) &&  action.payload.chatroom == state.currentChat){
          var newstuff =[action.payload].concat(state.messages)
          // console.log(newstuff.length,action.payload)          
          return {
            ...state,
            messages:newstuff,
            lastVisible: action.payload,
            isListening:true
          };
        }else{
          return {
              ...state,          
            };
          }  
        }      
        else{
          
          return {
            ...state,
            messages: [action.payload],
            lastVisible: action.payload,
          };

        }
      
      }else{
        return {
          ...state,
        }
      }
    case SEND_MESSSAGE:
      // console.log(action.payload)
   
      return {
        ...state,

      };

    case ADD_CHAT_SUBSCRIPTION:
      // console.log(action.payload)
    
      console.log('ADD_CHAT_SUBSCRIPTION', action.newList)
      return {
        ...state,
        subscribedList:action.newList,
        currentChat:action.payload

      };



    case CHANGE_CHAT:    
      return {
        ...state,
        messages: [],
        idlist:[],
        lastVisible: null,
        getDone:false,
        isListening:false,
        currentChat:action.payload
      };

    default:
      return state;
  }
};

export default chatReducer;
